import {
  AddressType,
  DeliveryFeeOrigin,
  DeliveryStatus,
  OrderStatus,
  PaymentStatus,
  PriceOrigin,
  ProspectionType,
  QrCodeStatus,
  ScanAction,
  SignatureMode,
  StockExitReason,
  TaskPriority,
  TaskStatus,
  UserRole,
  VisitOutcome,
} from "../__generated__/globalTypes";

const ADDRESS_TYPE_LABELS: Record<AddressType, string> = {
  [AddressType.Billing]: "Facturation",
  [AddressType.Delivery]: "Livraison",
  [AddressType.Head]: "Siège",
};

const DELIVERY_FEE_ORIGIN_LABELS: Record<DeliveryFeeOrigin, string> = {
  [DeliveryFeeOrigin.Auto]: "Automatique",
  [DeliveryFeeOrigin.Franco]: "Franco",
  [DeliveryFeeOrigin.FreeManual]: "Gratuit (manuel)",
};

const DELIVERY_STATUS_LABELS: Record<DeliveryStatus, string> = {
  [DeliveryStatus.Delivered]: "Livrée",
  [DeliveryStatus.Failed]: "Échec",
  [DeliveryStatus.InProgress]: "En cours",
  [DeliveryStatus.Planned]: "Planifiée",
  [DeliveryStatus.ToPlan]: "À planifier",
};

const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  [OrderStatus.Cancelled]: "Annulée",
  [OrderStatus.Draft]: "Brouillon",
  [OrderStatus.InSignature]: "En signature",
  [OrderStatus.Signed]: "Signée",
};

const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  [PaymentStatus.Paid]: "Payé",
  [PaymentStatus.Partial]: "Partiel",
  [PaymentStatus.Unpaid]: "Impayé",
};

const PRICE_ORIGIN_LABELS: Record<PriceOrigin, string> = {
  [PriceOrigin.Manual]: "Prix libre",
  [PriceOrigin.PriceRule]: "Règle de prix",
};

const PROSPECTION_TYPE_LABELS: Record<ProspectionType, string> = {
  [ProspectionType.Phone]: "Téléphone",
  [ProspectionType.Email]: "Email",
};

const QR_CODE_STATUS_LABELS: Record<QrCodeStatus, string> = {
  [QrCodeStatus.Assigned]: "Attribué",
  [QrCodeStatus.Available]: "Disponible",
};

const SCAN_ACTION_LABELS: Record<ScanAction, string> = {
  [ScanAction.Delivery]: "Livraison",
  [ScanAction.InventoryCheck]: "Contrôle d'inventaire",
  [ScanAction.PickUp]: "Prise en charge",
  [ScanAction.Return]: "Retour",
};

const SIGNATURE_MODE_LABELS: Record<SignatureMode, string> = {
  [SignatureMode.InPerson]: "En personne",
  [SignatureMode.Remote]: "À distance",
};

const STOCK_EXIT_REASON_LABELS: Record<StockExitReason, string> = {
  [StockExitReason.Issue]: "Incident",
  [StockExitReason.Promotion]: "Promotion",
  [StockExitReason.Sold]: "Vendu",
};

const TASK_PRIORITY_LABELS: Record<TaskPriority, string> = {
  [TaskPriority.High]: "Haute",
  [TaskPriority.Low]: "Basse",
  [TaskPriority.Medium]: "Moyenne",
};

const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  [TaskStatus.Cancelled]: "Annulée",
  [TaskStatus.Done]: "Terminée",
  [TaskStatus.InProgress]: "En cours",
  [TaskStatus.Todo]: "À faire",
};

const USER_ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.Admin]: "Administrateur",
  [UserRole.Client]: "Client",
  [UserRole.Employee]: "Employé",
};

const VISIT_OUTCOME_LABELS: Record<VisitOutcome, string> = {
  [VisitOutcome.NoAction]: "Aucune action",
  [VisitOutcome.Order]: "Commande",
  [VisitOutcome.Quote]: "Devis",
  [VisitOutcome.ToFollowUp]: "À relancer",
};

export const addressTypeLabel = (value?: AddressType | string | null) =>
  (value && ADDRESS_TYPE_LABELS[value as AddressType]) ?? value ?? "";

export const deliveryFeeOriginLabel = (value?: DeliveryFeeOrigin | string | null) =>
  (value && DELIVERY_FEE_ORIGIN_LABELS[value as DeliveryFeeOrigin]) ?? value ?? "";

export const deliveryStatusLabel = (value?: DeliveryStatus | string | null) =>
  (value && DELIVERY_STATUS_LABELS[value as DeliveryStatus]) ?? value ?? "";

export const orderStatusLabel = (value?: OrderStatus | string | null) =>
  (value && ORDER_STATUS_LABELS[value as OrderStatus]) ?? value ?? "";

export const paymentStatusLabel = (value?: PaymentStatus | string | null) =>
  (value && PAYMENT_STATUS_LABELS[value as PaymentStatus]) ?? value ?? "";

export const priceOriginLabel = (value?: PriceOrigin | string | null) =>
  (value && PRICE_ORIGIN_LABELS[value as PriceOrigin]) ?? value ?? "";

export const prospectionTypeLabel = (value?: ProspectionType | string | null) =>
  (value && PROSPECTION_TYPE_LABELS[value as ProspectionType]) ?? value ?? "";

export const qrCodeStatusLabel = (value?: QrCodeStatus | string | null) =>
  (value && QR_CODE_STATUS_LABELS[value as QrCodeStatus]) ?? value ?? "";

export const scanActionLabel = (value?: ScanAction | string | null) =>
  (value && SCAN_ACTION_LABELS[value as ScanAction]) ?? value ?? "";

export const signatureModeLabel = (value?: SignatureMode | string | null) =>
  (value && SIGNATURE_MODE_LABELS[value as SignatureMode]) ?? value ?? "";

export const stockExitReasonLabel = (value?: StockExitReason | string | null) =>
  (value && STOCK_EXIT_REASON_LABELS[value as StockExitReason]) ?? value ?? "";

export const taskPriorityLabel = (value?: TaskPriority | string | null) =>
  (value && TASK_PRIORITY_LABELS[value as TaskPriority]) ?? value ?? "";

export const taskStatusLabel = (value?: TaskStatus | string | null) =>
  (value && TASK_STATUS_LABELS[value as TaskStatus]) ?? value ?? "";

export const userRoleLabel = (value?: UserRole | string | null) =>
  (value && USER_ROLE_LABELS[value as UserRole]) ?? value ?? "";

export const visitOutcomeLabel = (value?: VisitOutcome | string | null) =>
  (value && VISIT_OUTCOME_LABELS[value as VisitOutcome]) ?? value ?? "";
